import React, {FC} from 'react';
import styled from 'styled-components';
import {createHelpCenterArticleUrl} from '../../../pages/HelpCenter/routes';
import {
  HelpCenterArticlePageData,
  HelpCenterPageCommonProps,
} from '../../../pages/HelpCenter/types';
import {exists} from '../../../utils/exists';
import QuestionCard from '../../Card/QuestionCard';
import {
  QueryColumnCount,
  TitledGridSection,
} from '../../Sections/TitledGridSection';
import {backgroundColor, bordersColor} from '../../constants/colors';
import {
  desktopLargeMinWidth,
  mediaMinDesktopLarge,
  mediaMinTablet,
  tabletMinWidth,
} from '../../constants/customMedia';
import PageWrapper from '../common/PageWrapper';

interface Props {
  title: string;
  articles: HelpCenterArticlePageData['relatedArticles'];
  sections: HelpCenterPageCommonProps['sections'];
}

const FullWidthWrapper = styled.div`
  background-color: ${backgroundColor};
  padding-top: 60px;
  width: 100%;

  @media ${mediaMinTablet} {
    padding-top: 0;
    border-top: 1px solid ${bordersColor};
    margin-top: 120px;
  }
`;

const gridColumnConfig: QueryColumnCount[] = [
  [
    `only screen and (min-width: 0px) and (max-width: ${tabletMinWidth - 1}px)`,
    1,
  ],
  [
    `only screen and (min-width: ${tabletMinWidth}px) and (max-width: ${
      desktopLargeMinWidth - 1
    }px)`,
    2,
  ],
  [mediaMinDesktopLarge, 3],
];

const RelatedArticles: FC<Props> = ({title, articles, sections}) => {
  if (!articles || articles.length === 0) {
    return null;
  }
  const articlesWithSection = articles
    .map(article => {
      const section = sections.find(
        section => section.id === article.section_id,
      );

      if (!section) {
        return null;
      }

      return {section, article};
    })
    .filter(exists);

  return (
    <FullWidthWrapper>
      <PageWrapper>
        <TitledGridSection
          containerDataTestId="HelpCenterRelatedArticlesSection"
          titleDataTestId="HelpCenterRelatedArticlesTitle"
          columnCount={gridColumnConfig}
          gridGap={20}
          title={title}
        >
          {articlesWithSection.map(({article, section}) => (
            <QuestionCard
              bold
              dataTestId="HelpCenterRelatedArticleLink"
              key={article.id}
              label={article.name}
              to={createHelpCenterArticleUrl(section, article)}
            />
          ))}
        </TitledGridSection>
      </PageWrapper>
    </FullWidthWrapper>
  );
};

export default RelatedArticles;
